import RegisterSuccessPostDoc from "./RegisterSuccessPostDoc";
export default RegisterSuccessPostDoc;
